<app-modal-title>
  <div>
    <span class="is-pulled-left" i18n>Notifications</span>
    <button id="notification-panel-close-button" tabindex="0"
      class="ot-aboutbox__close ot-modal-close ot-close-icon is-pulled-right" i18n-title title="Close"
      (click)="close()"></button>
  </div>
</app-modal-title>
<app-modal-body>
  <app-tabs [identifier]="'notification-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="notificationTabs"
    [color]="TabColor.SECONDARY" [selectedIndex]="activeTab"></app-tabs>
  <div #notificationMenu class="ot-dropdown notification-dropdown"
    [ngClass]="{'ot-dropdown--is-active': showNotificationMenu}" (keyup)="onKeyToggleNotificationMenu($event)">
    <span #notificationMenuButton id="notification-panel-more-button" class="notification-dropdown-button "
      aria-label="trigger" (click)="toggleNotificationMenu()" role="button">
      <i class="otsc-icon-sprite otsc-icon-sprite-more"></i>
    </span>
    <ul id="notification-panel-more-list" class="ot-dropdown__menu">
      <li name="notification-panel-more-item" id="ot-header__item__more" class="ot-dropdown__item"
        (click)="goToMoreNotifications()" (keyup.enter)="goToMoreNotifications()" tabindex="0">
        <span i18n>More notifications</span>
      </li>
      @if (showNotificatiosSettingsMenu) {
      <li class="ot-dropdown__divider"></li>
      }
      @if (showNotificatiosSettingsMenu) {
      <li name="notification-panel-more-item" id="ot-header__item__settings" class="ot-dropdown__item"
        (click)="goToSettingsNotifications()" (keyup.enter)="goToSettingsNotifications()" tabindex="0">
        <span i18n>Go to Settings</span>
      </li>
      }
    </ul>
  </div>
  @if (activeTab == NotificationTab.GENERAL && !isLoading) {
  <div id="general-tab" class="ot-notification-tab">
    @if (notifications.length > 0) {
    <ng-scrollbar>
      <div id="notification-panel-general-list" class="ot-notification-list">
        @for (notification of notifications | slice:0:maxDisplayGeneral; track notification) {
        <div name="notification-panel-general-item" class="ot-notification ot-row" tabindex="0"
          (click)="handleNotificationLink(notification)" (keyup.enter)="handleNotificationLink(notification)">
          <div class="ot-notification-content">
            <span class="ot-notification-icon ot-row__column ot-row__column--is-20">
              <img name="notification-panel-general-item-icon" [alt]="notification.alt" [src]="notification.icon"
                class="ot-dropdown__icon">
            </span>
            <span class="ot-notification-details ot-row__column ot-row__column--is-80">
              <span name="notification-panel-general-item-timestamp" class="ot-notification-timestamp">
                {{notification.timestamp | date:'LLL d, yyyy h:mm:ss aa'}}
              </span>
              <span name="notification-panel-general-item-title" class="ot-notification-title">
                <b>{{notification.message}}</b>
              </span>
              <span name="notification-panel-general-item-text" class="ot-notification-text">
                {{notification.messageText}}
              </span>
            </span>
          </div>
        </div>
        }
        <div id="notification-panel-general-item-more" class="ot-notification ot-notification-more ot-row"
          (click)="goToMoreNotifications(notification)" (keyup.enter)="goToMoreNotifications(notification)">
          <div class="ot-notification-content">
            <span class="ot-notification-icon ot-row__column ot-row__column--is-20">
              <img name="notification-panel-general-item-icon" i18n-alt alt="Go to notifications"
                src="./assets/icons/toolbar_go-to-location24.svg" class="ot-dropdown__icon">
            </span>
            <span class="ot-notification-details ot-row__column ot-row__column--is-80">
              <span name="notification-panel-general-item-title" class="ot-notification-title">
                <b i18n>View more notifications</b>
              </span>
            </span>
          </div>
        </div>
      </div>
    </ng-scrollbar>
    }
    @if (notifications.length == 0) {
    <div id="notification-panel-general-empty" class="otsc-empty-notification-list-container">
      <div>
        <img id="notification-panel-general-empty-image" src="./assets/icons/ill_assignments220.svg"
          alt="No notifications" i18n-alt>
        <div id="notification-panel-general-empty-text" i18n>You are all caught up!</div>
      </div>
    </div>
    }
  </div>
  }
  @if (activeTab == NotificationTab.SYSTEM && !isLoading) {
  <div id="system-tab" class="ot-notification-tab">
    @if (systemNotifications.length > 0) {
    <ng-scrollbar>
      <div id="notification-panel-system-list" class="ot-notification-list">
        @for (notification of systemNotifications | slice:0:10 ; track notification) {
        <div name="notification-panel-system-item" class="ot-notification ot-row" tabindex="0"
          (click)="handleNotificationLink(notification)" (keyup.enter)="handleNotificationLink(notification)">
          <div class="ot-notification-content">
            <span class="ot-notification-icon ot-row__column ot-row__column--is-20">
              <img name="notification-panel-system-item-icon" [alt]="notification.alt" [src]="notification.icon"
                class="ot-dropdown__icon">
            </span>
            <span class="ot-notification-details ot-row__column ot-row__column--is-80">
              <span name="notification-panel-system-item-timestamp" class="ot-notification-timestamp">
                {{notification.timestamp | date:'LLL d, yyyy h:mm:ss aa'}}
              </span>
              <span name="notification-panel-system-item-title" class="ot-notification-title">
                <b>{{notification.message}}</b>
              </span>
              <span name="notification-panel-system-item-text" class="ot-notification-text">
                {{notification.messageText}}
              </span>
            </span>
          </div>
        </div>
        }
      </div>
    </ng-scrollbar>
    }
    @if (systemNotifications.length == 0) {
    <div id="notification-panel-system-empty" class="otsc-empty-notification-list-container">
      <div>
        <img id="notification-panel-system-empty-image" src="./assets/icons/ill_assignments220.svg"
          alt="No notifications" i18n-alt>
        <div id="notification-panel-system-empty-text" i18n>You are all caught up!</div>
      </div>
    </div>
    }
  </div>
  }
  @if (isLoading) {
  <div id="notification-panel-loading" style="height: calc(100vh - 152px)">
    <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
      <div class="ot-progress__outer">
        <div class="ot-progress__meter">
        </div>
      </div>
    </div>
  </div>
  }
</app-modal-body>
<app-modal-footer>
  <button id="notification-panel-cancel-button" class="ot-btn ot-btn--is-primary" i18n-title title="Close"
    (click)="close()" i18n>
    Close
  </button>
</app-modal-footer>